// eslint-disable-next-line
import React, { Fragment, useState, useEffect } from 'react';
import UserDegreeHistoryAccordionItem from './UserDegreeHistoryAccordionItem';
import { genPageData } from '../../langconfig/langconfig'; // eslint-disable-next-line
const UserDegreeHistroyAccordion = ({ userDegreeData, showData, data, pageLanguageContent, profileId, memebrshipStatus,updateData }) => {
	const [clicked, setClicked] = useState(0);
	useEffect(() => {
		// eslint-disable-next-line
	}, [showData]);

	const handleToggle = index => {
		if (clicked === index) {
			return setClicked('0');
		}
		setClicked(index);
	};

	return (
		<>
			{userDegreeData && userDegreeData.length > 0 ? (
				userDegreeData.map((item, index) => (
					<UserDegreeHistoryAccordionItem
						onToggle={() => handleToggle(index)}
						active={clicked === index}
						key={index}
						data={item}
						currentIndex={index}
						profileId={profileId}
						pageLanguageContent={pageLanguageContent}
					/>
				))
			) : (
				<p className="text-center">{genPageData['GENDNF'] ? genPageData['GENDNF'] : ''}.</p>
			)}
		</>
	);
};

export default UserDegreeHistroyAccordion;
